/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.ts to modify the generation of this file.



import * as Login from 'src/components/account/Login/Login';
import * as LoginFormFields from 'src/components/account/Login/LoginFormFields';
import * as LoginFields from 'src/components/account/Login/_Fields/LoginFields';
import * as _ForgotPassword from 'src/components/account/Login/_ForgotPassword/_ForgotPassword';
import * as _ForgotPasswordRichText from 'src/components/account/Login/_ForgotPassword/_ForgotPasswordRichText';
import * as _FormErrorBox from 'src/components/account/Login/_FormErrorBox/_FormErrorBox';
import * as LoginHeader from 'src/components/account/Login/_Header/LoginHeader';
import * as _SecureSignInForm from 'src/components/account/Login/_SecureSignInForm/_SecureSignInForm';
import * as _SupportLinks from 'src/components/account/Login/_SupportLinks/_SupportLinks';
import * as Welcome from 'src/components/account/Welcome/Welcome';
import * as Advert from 'src/components/advert/Advert/Advert';
import * as GaTrackAccessToContent from 'src/components/analytics/GaTrackAccessToContent';
import * as ContentListing from 'src/components/basicContent/ContentListing/ContentListing';
import * as FAQListing from 'src/components/basicContent/FAQListing/FAQListing';
import * as FileDownload from 'src/components/basicContent/fileDownload/FileDownload';
import * as ImageComponent from 'src/components/basicContent/ImageComponent/ImageComponent';
import * as InformationPanels from 'src/components/basicContent/InformationPanel/InformationPanels';
import * as Instructions from 'src/components/basicContent/Instructions/Instructions';
import * as IntroText from 'src/components/basicContent/IntroText/IntroText';
import * as KnowledgeChecker from 'src/components/basicContent/KnowledgeChecker/KnowledgeChecker';
import * as PageTitle from 'src/components/basicContent/PageTitle/PageTitle';
import * as PageTitleWithImage from 'src/components/basicContent/PageTitleWithImage/PageTitleWithImage';
import * as SectionHeader from 'src/components/basicContent/SectionHeader/SectionHeader';
import * as ShareContentButton from 'src/components/basicContent/ShareContentButton/ShareContentButton';
import * as Testimonials from 'src/components/basicContent/Testimonials/Testimonials';
import * as TextBanner from 'src/components/basicContent/TextBanner/TextBanner';
import * as TextBlock from 'src/components/basicContent/TextBlock/TextBlock';
import * as TextCarousel from 'src/components/basicContent/TextCarousel/TextCarousel';
import * as Video from 'src/components/basicContent/Video/Video';
import * as VideoCollection from 'src/components/basicContent/VideoCollection/VideoCollection';
import * as Accordion from 'src/components/basicContent/_Accordion/Accordion';
import * as BackToTop from 'src/components/basicContent/_BackToTop/BackToTop';
import * as Button from 'src/components/basicContent/_Button/Button';
import * as ButtonWithLoader from 'src/components/basicContent/_ButtonWithLoader/ButtonWithLoader';
import * as _CardAttributeList from 'src/components/basicContent/_CardAttributeList/_CardAttributeList';
import * as _ContentCard from 'src/components/basicContent/_ContentCard/_ContentCard';
import * as _MicroModal from 'src/components/basicContent/_MicroModal/_MicroModal';
import * as Modal from 'src/components/basicContent/_Modal/Modal';
import * as Pill from 'src/components/basicContent/_Pill/Pill';
import * as ShareContent from 'src/components/basicContent/_shareContent/ShareContent';
import * as _SlideOut from 'src/components/basicContent/_SlideOut/_SlideOut';
import * as Swiper from 'src/components/basicContent/_Swiper/Swiper';
import * as SwiperComponent from 'src/components/basicContent/_Swiper/SwiperComponent';
import * as SwiperSlideComponent from 'src/components/basicContent/_Swiper/SwiperSlideComponent';
import * as SwiperSlideTo from 'src/components/basicContent/_Swiper/SwiperSlideTo';
import * as Transition from 'src/components/basicContent/_Transition/Transition';
import * as VideoItem from 'src/components/basicContent/_VideoPlayer/VideoItem';
import * as VideoPlayer from 'src/components/basicContent/_VideoPlayer/VideoPlayer';
import * as AccessLevelGroupCallToAction from 'src/components/callToActions/AccessLevelGroupCallToAction/AccessLevelGroupCallToAction';
import * as CallToActionCarousel from 'src/components/callToActions/CallToActionCarousel/CallToActionCarousel';
import * as ForumSignpost from 'src/components/callToActions/ForumSignpost/ForumSignpost';
import * as GroupCallToAction from 'src/components/callToActions/GroupCallToAction/GroupCallToAction';
import * as GroupImageCallToAction from 'src/components/callToActions/GroupImageCallToAction/GroupImageCallToAction';
import * as HeroBlock from 'src/components/callToActions/HeroBlock/HeroBlock';
import * as ImageCallToAction from 'src/components/callToActions/ImageCallToAction/ImageCallToAction';
import * as ImageDoubleCallToAction from 'src/components/callToActions/ImageDoubleCallToAction/ImageDoubleCallToAction';
import * as RcnFoundationPromotion from 'src/components/callToActions/rcnFoundationPromotion/RcnFoundationPromotion';
import * as SearchHeroBlock from 'src/components/callToActions/SearchHeroBlock/SearchHeroBlock';
import * as TextCallToAction from 'src/components/callToActions/TextCallToAction/TextCallToAction';
import * as RcniLinkFields from 'src/components/contentOverview/RcniLinkFields';
import * as WildCardFields from 'src/components/contentOverview/WildCardFields';
import * as ContentOverviewActionButton from 'src/components/contentOverview/contentOverviewActionButton/ContentOverviewActionButton';
import * as ContentOverviewAudience from 'src/components/contentOverview/contentOverviewAudience/ContentOverviewAudience';
import * as ContentOverviewAudienceContainer from 'src/components/contentOverview/contentOverviewAudience/contentOverviewAudienceContainer/ContentOverviewAudienceContainer';
import * as ContentOverviewAuthors from 'src/components/contentOverview/contentOverviewAuthors/ContentOverviewAuthors';
import * as ContentOverviewCallToAction from 'src/components/contentOverview/contentOverviewCallToAction/ContentOverviewCallToAction';
import * as ContentOverviewCallToActionProps from 'src/components/contentOverview/contentOverviewCallToAction/ContentOverviewCallToActionProps';
import * as ContentOverviewCertificateOfCompletion from 'src/components/contentOverview/contentOverviewCallToAction/ContentOverviewCertificateOfCompletion';
import * as ContentOverviewDownloadHeader from 'src/components/contentOverview/contentOverviewDownloadHeader/ContentOverviewDownloadHeader';
import * as ContentOverviewLeads from 'src/components/contentOverview/contentOverviewLeads/ContentOverviewLeads';
import * as ContentOverviewLeadsFields from 'src/components/contentOverview/contentOverviewLeads/ContentOverviewLeadsFields';
import * as contentOverviewLeadCard from 'src/components/contentOverview/contentOverviewLeads/_contentOverviewLeadCard/contentOverviewLeadCard';
import * as ContentOverviewModals from 'src/components/contentOverview/contentOverviewModals/ContentOverviewModals';
import * as ContentOverviewPortfolioCallToAction from 'src/components/contentOverview/contentOverviewPortfolioCallToAction/ContentOverviewPortfolioCallToAction';
import * as ContentOverviewQualityAssuranceStatement from 'src/components/contentOverview/contentOverviewQualityAssuranceStatement/ContentOverviewQualityAssuranceStatement';
import * as ContentOverviewRelatedResourcesCourses from 'src/components/contentOverview/contentOverviewRelatedResourcesCourses/ContentOverviewRelatedResourcesCourses';
import * as ContentOverviewRelatedResourcesCoursesCard from 'src/components/contentOverview/contentOverviewRelatedResourcesCourses/ContentOverviewRelatedResourcesCoursesCard/ContentOverviewRelatedResourcesCoursesCard';
import * as ContentOverviewResourceNavigation from 'src/components/contentOverview/contentOverviewResourceNavigation/ContentOverviewResourceNavigation';
import * as ContentOverviewSponsors from 'src/components/contentOverview/contentOverviewSponsors/ContentOverviewSponsors';
import * as ContentOverviewSummary from 'src/components/contentOverview/contentOverviewSummary/ContentOverviewSummary';
import * as ContentOverviewSummaryFields from 'src/components/contentOverview/contentOverviewSummary/ContentOverviewSummaryFields';
import * as ContentOverviewAbstract from 'src/components/contentOverview/contentOverviewSummary/_contentOverviewAbstract/ContentOverviewAbstract';
import * as ContentOverviewTile from 'src/components/contentOverview/contentOverviewSummary/_contentOverviewTile/ContentOverviewTile';
import * as ContentOverviewToolbar from 'src/components/contentOverview/contentOverviewToolbar/ContentOverviewToolbar';
import * as ContentOverviewToolbarFields from 'src/components/contentOverview/contentOverviewToolbar/ContentOverviewToolbarFields';
import * as DownloadButton from 'src/components/contentOverview/contentOverviewToolbar/_contentOverviewDownloadButton/DownloadButton';
import * as DownloadOptions from 'src/components/contentOverview/contentOverviewToolbar/_contentOverviewDownloadButton/DownloadOptions/DownloadOptions';
import * as ReadTime from 'src/components/contentOverview/contentOverviewToolbar/_contentOverviewReadTime/ReadTime';
import * as ContentOverviewWhyReadArticle from 'src/components/contentOverview/contentOverviewWhyReadArticle/ContentOverviewWhyReadArticle';
import * as LearningModuleOverviewInformation from 'src/components/contentOverview/learningModuleOverviewInformation/LearningModuleOverviewInformation';
import * as LearningModuleOverviewSyllabus from 'src/components/contentOverview/learningModuleOverviewSyllabus/LearningModuleOverviewSyllabus';
import * as ContentOverviewHeaderContainer from 'src/components/contentOverview/_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';
import * as CourseFields from 'src/components/courseOverview/CourseFields';
import * as CourseOverviewCohorts from 'src/components/courseOverview/courseOverviewCohorts/CourseOverviewCohorts';
import * as CourseOverviewContents from 'src/components/courseOverview/courseOverviewContents/CourseOverviewContents';
import * as CourseOverviewContentTypes from 'src/components/courseOverview/courseOverviewContents/CourseOverviewContentTypes';
import * as CourseOverviewCost from 'src/components/courseOverview/courseOverviewCost/CourseOverviewCost';
import * as CourseOverviewCostFields from 'src/components/courseOverview/courseOverviewCost/CourseOverviewCostFields';
import * as CourseOverviewEnrolment from 'src/components/courseOverview/CourseOverviewEnrolment/CourseOverviewEnrolment';
import * as CourseOverviewFindOutMore from 'src/components/courseOverview/courseOverviewFindOutMore/CourseOverviewFindOutMore';
import * as CourseOverviewLearningOutcomes from 'src/components/courseOverview/courseOverviewLearningOutcomes/CourseOverviewLearningOutcomes';
import * as CourseOverviewModeOfDelivery from 'src/components/courseOverview/courseOverviewModeOfDelivery/CourseOverviewModeOfDelivery';
import * as CourseOverviewSignUp from 'src/components/courseOverview/courseOverviewSignUp/CourseOverviewSignUp';
import * as CourseOverviewTestimonialList from 'src/components/courseOverview/courseOverviewTestimonialList/CourseOverviewTestimonialList';
import * as ErrorBoundary from 'src/components/errors/ErrorBoundary/ErrorBoundary';
import * as _NotFound from 'src/components/errors/_NotFound/_NotFound';
import * as SitecoreForm from 'src/components/forms/SitecoreForm/SitecoreForm';
import * as DisclaimerBanner from 'src/components/global/DisclaimerBanner/DisclaimerBanner';
import * as Footer from 'src/components/global/Footer/Footer';
import * as _FooterBackToTop from 'src/components/global/Footer/_FooterBackToTop';
import * as Header from 'src/components/global/Header/Header';
import * as HeaderFields from 'src/components/global/Header/HeaderFields';
import * as NavigationMenu from 'src/components/global/Header/NavigationMenu';
import * as _AccessLevelMenus from 'src/components/global/Header/_AccessLevelHeaderContent/_AccessLevelMenus';
import * as _HamburgerMenu from 'src/components/global/Header/_AccessLevelHeaderContent/_HamburgerMenu/_HamburgerMenu';
import * as _MenuHeading from 'src/components/global/Header/_AccessLevelHeaderContent/_HamburgerMenu/_MenuHeading/_MenuHeading';
import * as _PersonalisedLinks from 'src/components/global/Header/_AccessLevelHeaderContent/_HamburgerMenu/_PersonalisedLinks/_PersonalisedLinks';
import * as _LoggedInButtons from 'src/components/global/Header/_AccessLevelHeaderContent/_LoggedInButtons/_LoggedInButtons';
import * as _LoggedOutButtons from 'src/components/global/Header/_AccessLevelHeaderContent/_LoggedOutButtons/_LoggedOutButtons';
import * as _WelcomeDropdown from 'src/components/global/Header/_AccessLevelHeaderContent/_WelcomeDropdown/_WelcomeDropdown';
import * as _MultiTierMenu from 'src/components/global/Header/_MultiTierMenu/_MultiTierMenu';
import * as SubMenu from 'src/components/global/Header/_MultiTierMenu/SubMenu/SubMenu';
import * as LastUpdated from 'src/components/global/LastUpdated/LastUpdated';
import * as Modals from 'src/components/global/Modals/Modals';
import * as QuickLinks from 'src/components/global/QuickLinks/QuickLinks';
import * as _Clarity from 'src/components/global/_Clarity/_Clarity';
import * as _GoogleTag from 'src/components/global/_GoogleTag/_GoogleTag';
import * as _GTVirtualPageView from 'src/components/global/_GoogleTag/_GTVirtualPageView';
import * as _GaScripts from 'src/components/global/_Gtm/_GaScripts';
import * as _GaSearchScripts from 'src/components/global/_Gtm/_GaSearchScripts';
import * as _GtmTag from 'src/components/global/_Gtm/_GtmTag';
import * as _Hotjar from 'src/components/global/_Hotjar/_Hotjar';
import * as OneTrust from 'src/components/global/_OneTrust/OneTrust';
import * as BackToHandbookIndex from 'src/components/handbook/BackToHandbookIndex/BackToHandbookIndex';
import * as HandbookIndex from 'src/components/handbook/HandbookIndex/HandbookIndex';
import * as FullWidth from 'src/components/layout/FullWidth/FullWidth';
import * as Layout from 'src/components/layout/Layout/Layout';
import * as ThreeThirds from 'src/components/layout/ThreeColumns/ThreeThirds';
import * as ThreeTabs from 'src/components/layout/ThreeTabs/ThreeTabs';
import * as TwentyFiveFiftyTwentyFive from 'src/components/layout/TwentyFiveFiftyTwentyFive/TwentyFiveFiftyTwentyFive';
import * as TwoHalves from 'src/components/layout/TwoHalves/TwoHalves';
import * as TwoThirdsOneThird from 'src/components/layout/TwoThirdsOneThird/TwoThirdsOneThird';
import * as _EditorHelp from 'src/components/layout/_EditorHelp/_EditorHelp';
import * as MembershipPricingTable from 'src/components/membership/MembershipPricingTable/MembershipPricingTable';
import * as Breadcrumbs from 'src/components/navigation/Breadcrumbs/Breadcrumbs';
import * as ResourceCard from 'src/components/resources/ResourceCard/ResourceCard';
import * as ResourceNavigation from 'src/components/resources/ResourceNavigation/ResourceNavigation';
import * as ResourceOverviewPageLink from 'src/components/resources/ResourceOverviewPageLink/ResourceOverviewPageLink';
import * as ResourcePrevNextNavigation from 'src/components/resources/ResourcePrevNextNavigation/ResourcePrevNextNavigation';
import * as ResourceSubjectGuides from 'src/components/resources/ResourceSubjectGuides/ResourceSubjectGuides';
import * as TextImageCard from 'src/components/resources/_TextImageCard/TextImageCard';
import * as TextImageCardFields from 'src/components/resources/_TextImageCard/TextImageCardFields';
import * as ContentDetail from 'src/components/search/ContentDetail/ContentDetail';
import * as ContentDetailFields from 'src/components/search/ContentDetail/ContentDetailFields';
import * as _ClinicalTopic from 'src/components/search/ContentDetail/_ContentDetailTypes/_ClinicalTopic';
import * as _CPDArticle from 'src/components/search/ContentDetail/_ContentDetailTypes/_CPDArticle';
import * as _LearningModule from 'src/components/search/ContentDetail/_ContentDetailTypes/_LearningModule';
import * as ContentDetailsHeader from 'src/components/search/ContentDetail/_ContentDetailTypes/_ContentDetailTypesComponents/ContentDetailsHeader';
import * as ContentDetailsMain from 'src/components/search/ContentDetail/_ContentDetailTypes/_ContentDetailTypesComponents/ContentDetailsMain';
import * as ContentSummary from 'src/components/search/ContentSummary/ContentSummary';
import * as CuratedListing from 'src/components/search/CuratedListing/CuratedListing';
import * as FavouritesListing from 'src/components/search/FavoritesListing/FavouritesListing';
import * as SearchBar from 'src/components/search/SearchBar/SearchBar';
import * as SearchBarFields from 'src/components/search/SearchBar/SearchBarFields';
import * as SearchListing from 'src/components/search/SearchListing/SearchListing';
import * as _BackToSearch from 'src/components/search/_BackToSearch/_BackToSearch';
import * as _ClearAll from 'src/components/search/_ClearAll/_ClearAll';
import * as _Favourite from 'src/components/search/_Favourite/_Favourite';
import * as _Listing from 'src/components/search/_Listing/_Listing';
import * as _ListingCard from 'src/components/search/_ListingCard/_ListingCard';
import * as _SearchFilter from 'src/components/search/_SearchFilter/_SearchFilter';
import * as SearchListingLoading from 'src/components/search/_SearchListingLoading/SearchListingLoading';
import * as ShareButton from 'src/components/search/_ShareButton/ShareButton';
import * as _ShareOptions from 'src/components/search/_ShareButton/_ShareOptions/_ShareOptions';
import * as _ShowMore from 'src/components/search/_ShowMore/_ShowMore';
import * as _SortByFilter from 'src/components/search/_SortBy/_SortByFilter';

const components = new Map();
components.set('Login', Login);
components.set('LoginFormFields', LoginFormFields);
components.set('LoginFields', LoginFields);
components.set('_ForgotPassword', _ForgotPassword);
components.set('_ForgotPasswordRichText', _ForgotPasswordRichText);
components.set('_FormErrorBox', _FormErrorBox);
components.set('LoginHeader', LoginHeader);
components.set('_SecureSignInForm', _SecureSignInForm);
components.set('_SupportLinks', _SupportLinks);
components.set('Welcome', Welcome);
components.set('Advert', Advert);
components.set('GaTrackAccessToContent', GaTrackAccessToContent);
components.set('ContentListing', ContentListing);
components.set('FAQListing', FAQListing);
components.set('FileDownload', FileDownload);
components.set('ImageComponent', ImageComponent);
components.set('InformationPanels', InformationPanels);
components.set('Instructions', Instructions);
components.set('IntroText', IntroText);
components.set('KnowledgeChecker', KnowledgeChecker);
components.set('PageTitle', PageTitle);
components.set('PageTitleWithImage', PageTitleWithImage);
components.set('SectionHeader', SectionHeader);
components.set('ShareContentButton', ShareContentButton);
components.set('Testimonials', Testimonials);
components.set('TextBanner', TextBanner);
components.set('TextBlock', TextBlock);
components.set('TextCarousel', TextCarousel);
components.set('Video', Video);
components.set('VideoCollection', VideoCollection);
components.set('Accordion', Accordion);
components.set('BackToTop', BackToTop);
components.set('Button', Button);
components.set('ButtonWithLoader', ButtonWithLoader);
components.set('_CardAttributeList', _CardAttributeList);
components.set('_ContentCard', _ContentCard);
components.set('_MicroModal', _MicroModal);
components.set('Modal', Modal);
components.set('Pill', Pill);
components.set('ShareContent', ShareContent);
components.set('_SlideOut', _SlideOut);
components.set('Swiper', Swiper);
components.set('SwiperComponent', SwiperComponent);
components.set('SwiperSlideComponent', SwiperSlideComponent);
components.set('SwiperSlideTo', SwiperSlideTo);
components.set('Transition', Transition);
components.set('VideoItem', VideoItem);
components.set('VideoPlayer', VideoPlayer);
components.set('AccessLevelGroupCallToAction', AccessLevelGroupCallToAction);
components.set('CallToActionCarousel', CallToActionCarousel);
components.set('ForumSignpost', ForumSignpost);
components.set('GroupCallToAction', GroupCallToAction);
components.set('GroupImageCallToAction', GroupImageCallToAction);
components.set('HeroBlock', HeroBlock);
components.set('ImageCallToAction', ImageCallToAction);
components.set('ImageDoubleCallToAction', ImageDoubleCallToAction);
components.set('RcnFoundationPromotion', RcnFoundationPromotion);
components.set('SearchHeroBlock', SearchHeroBlock);
components.set('TextCallToAction', TextCallToAction);
components.set('RcniLinkFields', RcniLinkFields);
components.set('WildCardFields', WildCardFields);
components.set('ContentOverviewActionButton', ContentOverviewActionButton);
components.set('ContentOverviewAudience', ContentOverviewAudience);
components.set('ContentOverviewAudienceContainer', ContentOverviewAudienceContainer);
components.set('ContentOverviewAuthors', ContentOverviewAuthors);
components.set('ContentOverviewCallToAction', ContentOverviewCallToAction);
components.set('ContentOverviewCallToActionProps', ContentOverviewCallToActionProps);
components.set('ContentOverviewCertificateOfCompletion', ContentOverviewCertificateOfCompletion);
components.set('ContentOverviewDownloadHeader', ContentOverviewDownloadHeader);
components.set('ContentOverviewLeads', ContentOverviewLeads);
components.set('ContentOverviewLeadsFields', ContentOverviewLeadsFields);
components.set('contentOverviewLeadCard', contentOverviewLeadCard);
components.set('ContentOverviewModals', ContentOverviewModals);
components.set('ContentOverviewPortfolioCallToAction', ContentOverviewPortfolioCallToAction);
components.set('ContentOverviewQualityAssuranceStatement', ContentOverviewQualityAssuranceStatement);
components.set('ContentOverviewRelatedResourcesCourses', ContentOverviewRelatedResourcesCourses);
components.set('ContentOverviewRelatedResourcesCoursesCard', ContentOverviewRelatedResourcesCoursesCard);
components.set('ContentOverviewResourceNavigation', ContentOverviewResourceNavigation);
components.set('ContentOverviewSponsors', ContentOverviewSponsors);
components.set('ContentOverviewSummary', ContentOverviewSummary);
components.set('ContentOverviewSummaryFields', ContentOverviewSummaryFields);
components.set('ContentOverviewAbstract', ContentOverviewAbstract);
components.set('ContentOverviewTile', ContentOverviewTile);
components.set('ContentOverviewToolbar', ContentOverviewToolbar);
components.set('ContentOverviewToolbarFields', ContentOverviewToolbarFields);
components.set('DownloadButton', DownloadButton);
components.set('DownloadOptions', DownloadOptions);
components.set('ReadTime', ReadTime);
components.set('ContentOverviewWhyReadArticle', ContentOverviewWhyReadArticle);
components.set('LearningModuleOverviewInformation', LearningModuleOverviewInformation);
components.set('LearningModuleOverviewSyllabus', LearningModuleOverviewSyllabus);
components.set('ContentOverviewHeaderContainer', ContentOverviewHeaderContainer);
components.set('CourseFields', CourseFields);
components.set('CourseOverviewCohorts', CourseOverviewCohorts);
components.set('CourseOverviewContents', CourseOverviewContents);
components.set('CourseOverviewContentTypes', CourseOverviewContentTypes);
components.set('CourseOverviewCost', CourseOverviewCost);
components.set('CourseOverviewCostFields', CourseOverviewCostFields);
components.set('CourseOverviewEnrolment', CourseOverviewEnrolment);
components.set('CourseOverviewFindOutMore', CourseOverviewFindOutMore);
components.set('CourseOverviewLearningOutcomes', CourseOverviewLearningOutcomes);
components.set('CourseOverviewModeOfDelivery', CourseOverviewModeOfDelivery);
components.set('CourseOverviewSignUp', CourseOverviewSignUp);
components.set('CourseOverviewTestimonialList', CourseOverviewTestimonialList);
components.set('ErrorBoundary', ErrorBoundary);
components.set('_NotFound', _NotFound);
components.set('SitecoreForm', SitecoreForm);
components.set('DisclaimerBanner', DisclaimerBanner);
components.set('Footer', Footer);
components.set('_FooterBackToTop', _FooterBackToTop);
components.set('Header', Header);
components.set('HeaderFields', HeaderFields);
components.set('NavigationMenu', NavigationMenu);
components.set('_AccessLevelMenus', _AccessLevelMenus);
components.set('_HamburgerMenu', _HamburgerMenu);
components.set('_MenuHeading', _MenuHeading);
components.set('_PersonalisedLinks', _PersonalisedLinks);
components.set('_LoggedInButtons', _LoggedInButtons);
components.set('_LoggedOutButtons', _LoggedOutButtons);
components.set('_WelcomeDropdown', _WelcomeDropdown);
components.set('_MultiTierMenu', _MultiTierMenu);
components.set('SubMenu', SubMenu);
components.set('LastUpdated', LastUpdated);
components.set('Modals', Modals);
components.set('QuickLinks', QuickLinks);
components.set('_Clarity', _Clarity);
components.set('_GoogleTag', _GoogleTag);
components.set('_GTVirtualPageView', _GTVirtualPageView);
components.set('_GaScripts', _GaScripts);
components.set('_GaSearchScripts', _GaSearchScripts);
components.set('_GtmTag', _GtmTag);
components.set('_Hotjar', _Hotjar);
components.set('OneTrust', OneTrust);
components.set('BackToHandbookIndex', BackToHandbookIndex);
components.set('HandbookIndex', HandbookIndex);
components.set('FullWidth', FullWidth);
components.set('Layout', Layout);
components.set('ThreeThirds', ThreeThirds);
components.set('ThreeTabs', ThreeTabs);
components.set('TwentyFiveFiftyTwentyFive', TwentyFiveFiftyTwentyFive);
components.set('TwoHalves', TwoHalves);
components.set('TwoThirdsOneThird', TwoThirdsOneThird);
components.set('_EditorHelp', _EditorHelp);
components.set('MembershipPricingTable', MembershipPricingTable);
components.set('Breadcrumbs', Breadcrumbs);
components.set('ResourceCard', ResourceCard);
components.set('ResourceNavigation', ResourceNavigation);
components.set('ResourceOverviewPageLink', ResourceOverviewPageLink);
components.set('ResourcePrevNextNavigation', ResourcePrevNextNavigation);
components.set('ResourceSubjectGuides', ResourceSubjectGuides);
components.set('TextImageCard', TextImageCard);
components.set('TextImageCardFields', TextImageCardFields);
components.set('ContentDetail', ContentDetail);
components.set('ContentDetailFields', ContentDetailFields);
components.set('_ClinicalTopic', _ClinicalTopic);
components.set('_CPDArticle', _CPDArticle);
components.set('_LearningModule', _LearningModule);
components.set('ContentDetailsHeader', ContentDetailsHeader);
components.set('ContentDetailsMain', ContentDetailsMain);
components.set('ContentSummary', ContentSummary);
components.set('CuratedListing', CuratedListing);
components.set('FavouritesListing', FavouritesListing);
components.set('SearchBar', SearchBar);
components.set('SearchBarFields', SearchBarFields);
components.set('SearchListing', SearchListing);
components.set('_BackToSearch', _BackToSearch);
components.set('_ClearAll', _ClearAll);
components.set('_Favourite', _Favourite);
components.set('_Listing', _Listing);
components.set('_ListingCard', _ListingCard);
components.set('_SearchFilter', _SearchFilter);
components.set('SearchListingLoading', SearchListingLoading);
components.set('ShareButton', ShareButton);
components.set('_ShareOptions', _ShareOptions);
components.set('_ShowMore', _ShowMore);
components.set('_SortByFilter', _SortByFilter);

// Next.js 'dynamic' import and JavaScript 'dynamic' import are different.
// Next.js 'dynamic(...)' returns common 'React.ComponentType' while
// 'import('...')' returns 'Promise' that will resolve module.
// componentModule uses 'import(...)' because primary usage of it to get not only 'React Component' (default export) but all named exports.
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#dynamic_imports
// componentFactory uses 'dynamic(...)' because primary usage of it to render 'React Component' (default export).
// See https://nextjs.org/docs/advanced-features/dynamic-import
// At the end you will have single preloaded script for each lazy loading module.

export function componentModule(componentName: string) {
  const component = components.get(componentName);

  // check that component is lazy loading module
  if (!component?.default && component?.module) {
    // return js dynamic import
    return component.module();
  }

  return component;
}
  
export function componentFactory(componentName: string) {
  const component = components.get(componentName);

  // check that component should be dynamically imported
  if (component?.element) {
    // return next.js dynamic import
    return component.element();
  }

  return component?.default || component;
}
